import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=6371bcb4"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=6371bcb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports